import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B090013FindRequest = {
  sokoCd: string;
  shohinCd: string;
} & Partial<{
  page: number;
  sort: string[];
  size: number;
}>;

export type B090013FindResponse = {
  juchudenpyoNo: string;
  hachudenpyoNo: string;
  shireCd: string;
  shireNmr: string;
  hachusu: string;
  shirezumisu: string;
  nyukayoteisu: string;
  nyukayoteiYmd: string;
};

export const B090013Find = (props: B090013FindRequest) => {
  return RestClient.get<PageableResponse<B090013FindResponse[]>>(
    "b090013/find",
    {
      params: props,
    }
  );
};
